/**
 * Settings Page - Coming Soon
 * Placeholder page for future settings functionality
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Settings, ArrowLeft, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';
import HadenAtlasLogo from '../components/HadenAtlasLogo';

const SettingsPage = () => {
  return (
    <div className="min-h-[calc(100vh-200px)] flex flex-col items-center justify-center p-8">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Icon */}
        <div className="mx-auto w-20 h-20 bg-[#101957]/10 rounded-full flex items-center justify-center">
          <Settings className="w-10 h-10 text-[#101957]" />
        </div>

        {/* Title */}
        <div>
          <h1 className="text-3xl font-bold text-[#101957] mb-2">Settings</h1>
          <div className="flex items-center justify-center gap-2 text-[#C8B59A]">
            <Clock className="w-4 h-4" />
            <span className="text-sm font-medium uppercase tracking-wider">Coming Soon</span>
          </div>
        </div>

        {/* Description */}
        <p className="text-slate-600">
          System settings and configuration options will be available here. 
          Manage application preferences, notifications, and more.
        </p>

        {/* Planned Features */}
        <div className="bg-slate-50 rounded-lg p-4 text-left">
          <h3 className="text-sm font-semibold text-[#101957] mb-2">Planned Features:</h3>
          <ul className="text-sm text-slate-600 space-y-1">
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#C8B59A] rounded-full"></span>
              Application preferences
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#C8B59A] rounded-full"></span>
              Notification settings
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#C8B59A] rounded-full"></span>
              Data export/import options
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#C8B59A] rounded-full"></span>
              System configuration
            </li>
          </ul>
        </div>

        {/* Back Button */}
        <Link to="/parts">
          <Button 
            variant="outline" 
            className="border-[#101957] text-[#101957] hover:bg-[#101957] hover:text-white"
            data-testid="settings-back-button"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Parts Catalogue
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default SettingsPage;
